<template>
  <div class="payrollSetting customerBox"
			v-loading="loading"
			element-loading-custom-class="customClass"
			:element-loading-text="reminderList.list[reminderList.current]"
       ref="payrollSetting">
    <div class="payrollBox" style="margin-bottom: -5px">
      <el-tabs v-model="tabIndex" type="card" style="height: calc(100vh - 80px);" >

        <el-tab-pane
          :key="item.name"
          v-for="(item, index) in salaryHistoryLists"
          :label="item.title"
          :name="'tab'+index"
        >
          <span slot="label">{{item.title}}<el-badge :value="item.num"></el-badge></span>
          <salaryDetail :tableData.sync="item.tableData"
            :idx="index"
            :ref="'forms'+index"
            :batchId="batchIdRoute"
            :isHistoryFlag="isHistoryFlag"
            :templateId="templateIdRoute"
            :taxType="item.taxType"
            :payGroupId="payGroupIdRoute"
            :orgId="orgIdRoute"
            :wageMonth="wageMonthRoute"
            :socMonth="socMonthRoute"
            :taxMonth="taxMonthRoute"
            :payWay="payWayRoute"
            :editState="editState"
            :isCompute="isCompute"
            :regionId="regionId"
            v-on:_getSalaryHistoryData="reloadWindow">

            <div class="btnCon">
							<div class="tooltip" v-if="index==0 && ( computeResultState=='ING' || computeResultState == 'FAIL')">
								<svg class="icon" aria-hidden="true">
<!--									<use xlink:href="#icon-jinggao"></use>-->
									<use xlink:href="#icon-tishi"></use>
								</svg>
								<span ref="tooltipCon" title="">{{computeResultMsg}}</span>
							</div>
              <el-select style="width: 200px; margin-right: 10px" v-model="listQuery.idCards" multiple collapse-tags :placeholder="$t('selectStaff')" filterable clearable
                         @change="handleSelectChange" @visible-change="handleSelectVisibleChange">
                <el-option v-for="item in emp" :key="item.id" :value="item.idCard" :label="item.empName" />
              </el-select>
              <el-button type="primary" size="small" @click="toAttachDetail()" >查看附件</el-button>
              <!--<el-button type="primary" size="small" @click="toImportPage()" v-if="editState==yes">导入</el-button>-->
              <el-button type="primary" size="small" @click="calculateCheckedData()" v-if="editState==yes">薪资试算</el-button>
              <el-button type="primary" size="small" @click="toSubmit(true)" v-if="editState==yes">确认提交</el-button>
              <el-button type="primary" size="small" @click="toColumnPage()" >自定义表头</el-button>
              <el-button type="primary" size="small" @click="exportTableData('forms'+index)">导出</el-button>
              <backBtn @reOnClick = "backToCodeSet()" style="display: inline-block;margin-left: 10px;"></backBtn>
<!--              <el-button type="primary" size="small" @click="backToCodeSet()">返回</el-button>-->
            </div>

          </salaryDetail>
         <div style="margin-top: 20px">
           <el-pagination @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="listQuery.page"
                          :page-sizes="[20,50,100,200,500]"
                          :page-size="listQuery.limit"
                          layout="total, sizes, prev, pager, next"
                          :total="listQuery.total">
           </el-pagination>
         </div>
        </el-tab-pane>


      </el-tabs>
    </div>
    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-loading="loading"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisibleHeaders"
    >
      <customHeader
        :headerType="1001"
        :headerList.sync="headerList"
        :templateId="templateIdRoute"
        :batchId="batchIdRoute">

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisibleHeaders = false">
          取消
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      ref=""
      id="dialog2"
      width="850px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="温馨提示"
      :visible.sync="dialogheaderVisible2"
    >
      <reminder :reminderList.sync="reminderList"></reminder>
    </el-dialog>
		<!-- <bspMask v-if="loading"><bspReminder :reminderList='reminderList'></bspReminder></bspMask> -->

    <!--确认的流程提示-->
    <el-dialog
      ref="confirm"
      id="dialog3"
      width="850px"
      v-dialogDrag
      @close="roteAction()"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="温馨提示"
      :visible.sync="dialogheaderVisibleConfirm"
    >
      <reminder :reminderList.sync="reminderListConfirm"></reminder>
      <div style="margin-top: 30px;text-align: center">
        <el-button
          type="primary"
          @click="roteAction()"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
    <bspMask v-if="loadingConfirm"><bspReminder :reminderList='reminderListConfirm'></bspReminder></bspMask>
  </div>
</template>

<script>

  import bspMask from "@/wage-components/bsp-mask/bsp-mask"
	import bspReminder from "@/wage-components/bsp-reminder/bsp-reminder"
	import salaryDetail from "./salary-detail"
  import {getSalaryTabs,saveWageItemColumns} from  "@/api/wage/salaryTemplate";
  import {calculateSalaryDetail, confirm, getItemDataList} from "@/api/wage/batchTemplate";
  import {updataCustHeaderInfo} from "@/api/wage/pay";
  // import customHeader from "@/components/ciic/ciic-custom-table-header/index";
  import customHeader from "@/views/wage/pay/customHeader/index";
  import { commonConst } from '@/const/code.js'
  import reminder from "@/views/demo/dataImport/template/reminder.vue";
  import store from '@/store';
  import {deepCopy} from '@/util/util';
  import exportMethod from "@/util/export"
  import SockJs from 'sockjs-client'
  import Stomp from 'stompjs'
  import backBtn from '@/wage-components/back-btn/back-btn'
  import {exportExcleSheets} from "@/api/common/common"
  import {queryEmpInfoListPage} from '@/api/v2/common'
	import { downloadFile } from '@/util/util';



  export default {
    name: "salaryTabs",
    props: {
      templateId: {
        type: String,
        default: '',
      },
      batchId: {
        type: String,
        default: '',
      },
      templateName: {
        type: String,
        default: "",
      },
      payGroupId: {
        type: String,
        default: "",
      },
      payGroupName: {
        type: String,
        default: "",
      }
    },
    components:{salaryDetail,customHeader,reminder,bspMask,bspReminder,backBtn},
    created(){
      this.initBtn();
      this.getEmpList();
      this._getSalaryHistoryData();
      this._getItemDataList();
    },
    data(){
      return{
        emp:[],
        tableData:[],
        tableDataCopy:[],
        reminderList:{
          title:'温馨提示',
          list:['请求计算','计算中，请稍后','计算完成'],//'数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'
          current:0
        },
        reminderListConfirm:{
          title:'',
          list:[],//'数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'
          current:0
        },
        dialogheaderVisibleHeaders: false,
        dialogheaderVisible2: false,
        dialogheaderVisibleConfirm: false,
        index: 0,
        salaryHistoryLists: [],
        templateIdRoute:this.$route.query.templateId,
        batchIdRoute:this.$route.query.batchId,
        regionRoute:this.$route.query.region,
        orgIdRoute:this.$route.query.orgId,
        payGroupIdRoute:this.$route.query.payGroupId,
        wageMonthRoute:this.$route.query.wageMonth,//工资月份
        socMonthRoute:this.$route.query.socMonth,//社保月份
        taxMonthRoute:this.$route.query.taxMonth,//税金月份
        payWayRoute:this.$route.query.payWay,//发放方式
        isHistoryFlag:this.$route.query.isHistoryFlag,//是否复制历史查询
        isCompute:this.$route.query.isCompute,//是否计算,判断是否工资条
        regionId:this.$route.query.regionId,//服务组合
        hasCiicSegName:this.$route.query.hasCiicSegName, //是否包含 中智核算
        tabIndex: 'tab0',
        listQuery:{
          page: 1,
          limit: 20,
          total:0,
          batchId:this.$route.query.batchId,//页面跳转带回参数batchId
        },
        headerList:[],//选择自定义列头保存数据
        loading:false,
        loadingConfirm:false,
        editState:commonConst.NO,//是否可编辑
        yes:commonConst.YES,//可编辑
        no:commonConst.NO,//不可编辑
        loadingTxt:'',
				firstLoad:false,
        computeResultState:'0',// 计算结果状态
        computeResultMsg:'待计算',//批次计算过程中的提示信息
        errorMsgFlag:false,
        headerType:'1001',//薪资历史/明细
        isSelectChange:false,
      }
    },
    updated(){
      if(this.firstLoad){
        this.firstLoad = false;
        setTimeout(() => {
            for(var i=0;i<this.salaryHistoryLists.length;i++){
                let dom = document.getElementById('tab-tab'+i);
                dom.style.left=-(i*20)+'px';
                dom.style.zIndex=--this.zIndex;
              };
        }, 100);
      }

    },
    methods: {
      //分页
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.listQuery.page = 1;
        this._getSalaryHistoryData();
        this._getItemDataList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this._getSalaryHistoryData();
        this._getItemDataList();
      },
      roteAction(){
        //跳转到数据准备
        this.$router.push({
          path: '/wage/data-ready-template'
        });
      },
      colseAction(){
        this.$router.go(-1);//返回刷新
      },
      reloadWindow(){
        this.$router.go(0);//刷新当前页
      },
      initBtn() {
        var cusId = this.$userInfo.cusId;
        //映喀迪定制化逻辑， 中智发薪也可以试算
        //todo 9999003977 为测试数据，上线时删除
        if(cusId == "9999003456" || cusId == "9999002747"){
          this.hasCiicSegName = '0';
        }
      },
      getEmpList() {
        queryEmpInfoListPage({cusId: this.$userInfo.cusId, limit: 100000}).then(res => {
          this.emp = res.data.records
        })
      },
      _getSalaryHistoryData(){
        let obj={templateId:this.templateIdRoute,batchId:this.batchIdRoute,isHistoryFlag:this.isHistoryFlag,wageMonth:this.wageMonthRoute,...this.listQuery};
        getSalaryTabs(obj).then(res=>{
          let rs=res.data;
          if(rs.code==0){
            this.salaryHistoryLists = rs.data.salaryHistoryLists;//页签信息
            this.editState = rs.data.editState;//是否可编辑状态
            this.index = 'tab0'
						this.firstLoad = true;
            this.computeResultState =rs.data.computeResultResult;
            this.computeResultMsg=rs.data.computeResultMsg;
            this.errorMsgFlag = rs.data.errorMsgFlag;
            if(this.computeResultState=="ING"){
              this.connect();
            }
            /*this.tableData = res.data.records;
            if(this.tableDataCopy.length==0){
              this.tableDataCopy = JSON.parse(JSON.stringify(res.data.records));
            }*/

          }/*else{
            this.$message.error('获取工资单数据出现问题')
          }*/
        })

      },
      handleSelectChange(val) {
        if (this.$isEmpty(val)) {
          // 如果val为空数组，则说明触发了清空，此时不会触发visible-change事件，需要手动查询后端
          //刷新页面
          this._getSalaryHistoryData();
          this.isSelectChange = false
        } else {
          this.isSelectChange = true
        }
      },
      handleSelectVisibleChange(val) {
        // 多选的blur无法触发，而change事件触发又过于频繁，因此此处使用visible-change，即多选后下拉框消失才会查询后端数据
        if (!val && this.isSelectChange) {
          //刷新页面
          this._getSalaryHistoryData();
          // 为了防止查询条件未变化时下拉框消失也查询后端，用此标识来记录select是否有变化，并在此处重置
          this.isSelectChange = false
        }
      },
      backToCodeSet(){
        this.$router.go(-1)
      },
      // 导出到excel
      exportTableData (id) {
        console.log('导出==========================')
        //获取新的表头
        exportExcleSheets(
          {
            columns: [],
            type: "excel",
            beanName: "wageBatchDetailServiceImpl",
            methodName: "getDetailForExcel",
            batchId: this.batchIdRoute,
            templateId:this.templateIdRoute,
            isHistoryFlag:this.isHistoryFlag,
            wageMonth : this.wageMonthRoute,
            isSort: true,
            headerRowNum: 2,
            fileName: "工资明细导出",
            fileType: ".xls",
          },
          "/wage",true
        ).then(res => {
					downloadFile(res)
				})
      },
      //跳转附件查看
      toAttachDetail(){
        const query = {batchId: this.batchIdRoute}
        console.log("详情参数query=",query);
        this.$router.push({ path: '/wage/attachmentManage', query});
      },

      // 分页查询按计税类型查询
      _getItemDataList() {
        this.listQuery.batchId = this.batchIdRoute;
        this.listQuery.templateId = this.templateIdRoute;
        this.listQuery.isHistoryFlag = this.isHistoryFlag;
        this.listQuery.wageMonth = this.wageMonthRoute;
        getItemDataList(this.listQuery).then((res) => {
          this.listQuery.total = res.data.total
          this.tableData = res.data.records;
          if(this.tableDataCopy.length==0){
            this.tableDataCopy = JSON.parse(JSON.stringify(res.data.records));
          }
        });
      },

      //跳转数据导入
      toImportPage(row) {
        const query = {
          templateId:'',//所选模板id
          templateName:'',//所选模板名称
          payGroupId:'',//薪酬组id
          payGroupName:'',//薪酬组名
        }
        console.log("详情参数query=",query);
        this.$router.push({ path: '/wage/data-ready-template', query});
      },
      //跳转自定义表头设置
      toColumnPage(){
        this.dialogheaderVisibleHeaders = true


      },
      //确认提交
      toSubmit(onlyConfirm){
        if(this.errorMsgFlag=="true"){
            this.$message.error("存在校验错误信息，请先处理错误数据");
            return;
        }
        if(this.computeResultState=="ING"){
            this.$message.error(this.computeResultMsg+",暂不能提交");
            return;
        }
        if(this.computeResultState=="FAIL"){
            this.$message.error(this.computeResultMsg+",请按要求修改批次数据，并重新计算后，再进行提交");
            return;
        }
        let params = {
          region:this.regionRoute,//服务组合
          orgId:this.orgIdRoute,//组织结构
          batchId:this.batchIdRoute,//批次
        }
        console.log("详情参数query=",this.formInline);
        //this.$router.push({ path: '/wagebatchinfo/confirm', query});
        if(onlyConfirm){
          this.$confirm('将针对整个批次进行提交，是否确认提交?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
              this.confirmData(params);
          })
        }else{
            this.confirmData(params);
        }
      },
      confirmData(params) {
        confirm(params).then(res=>{
            this.loading = false;
            let re = res.data
            if(re.code == 0){
                if(re.data.segNum!=null){
                    this.dialogheaderVisible2=false
                    this.dialogheaderVisibleConfirm=true;
                    //alert("流程编码======"+JSON.stringify(re.data));
                    let i = 0;
                    re.data.cusProcess.segList.forEach(item=>{
                        i+=1;
                        if(this.reminderListConfirm.list.length!=re.data.cusProcess.segList.length){
                            this.reminderListConfirm.list.push(item.segName);
                        }
                        if(item.segNum==re.data.segNum){
                            this.reminderListConfirm.title='批次数据已提交，下一环节【'+item.segName+'】。';
                            this.reminderListConfirm.current = i-1;
                            return;
                        }
                    });
                }else if(re.data.isCompute && re.data.isCompute==commonConst.YES){
                    //调用计算
                    this.calculateCheckedDataNextConfirm(true);
                }else{
                    this.$message.success("操作完成");
                }
            }
        })
      },
      //将选中的数据发送到计算中心
      calculateCheckedData: function(){
          if(this.errorMsgFlag=="true"){
              this.$message.error("存在校验错误信息，请先处理错误数据");
              return;
          }
          if(this.computeResultState=="ING"){
              this.$message.error(this.computeResultMsg+",请不要重复计算");
              return;
          }
          this.loading = true;
          this.loadingTxt = '请求计算';
          this.dialogheaderVisibleConfirm=false
          // Vue.$set(this.reminderList,'current',0)
          let obj={
            batchId: this.listQuery.batchId
          };
          calculateSalaryDetail(obj).then(res=>{
            let rs=res.data
            if(rs.code==0){
                this.loading = true;
                this.loadingTxt = rs.msg;
                this.computeResultState = "ING";
                this.computeResultMsg = "计算中，请稍后";
                this.connect();
                let delay = this.listQuery.total*1000; // 指定时间间隔(ms)
                if(delay<5000){
                  delay = 5000
                }
                setTimeout(() => {
                  this.loading = false;
                  this.$router.go(0);//刷新当前页
                }, delay);
            }else{
                this.loading = false;
                this.$message.error(rs.msg);
            }
          });
      },

      //将选中的数据发送到计算中心成功后再反调确认
      calculateCheckedDataNextConfirm: function(nextFlag){
        this.loading = true;
        this.dialogheaderVisibleConfirm=false
        // Vue.$set(this.reminderList,'current',0)
        let obj={
          batchId: this.listQuery.batchId
        };
        calculateSalaryDetail(obj).then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.loading = true;
            this.loadingTxt = rs.msg;
            this.connect(nextFlag);//此处计算完后调用提交
          }else{
            this.loading = false;
            this.$message.error(rs.msg);
          }
        });
      },
      //保存
      saveCusHeader(){
        if(this.headerList&&this.headerList.length==0){
          this.$message.warning('请选择表头内容')
          return ;
        }
        console.log('保存传参',this.headerList)
        let param = {
          'batchId':this.batchIdRoute,
          'templateId':this.templateIdRoute,
          'headers':this.headerList,
          'headerType':'1001'  //薪资历史
        }

        let value = this.tabIndex.substring(this.tabIndex.length-1,this.tabIndex.length);
        this.loading = true;
        updataCustHeaderInfo(param).then(res=>{
          this.loading = false;
          if(res.data.code==0){
            //刷新页面
            this._getSalaryHistoryData();
            this.$refs['forms'+value][0]._getItemColumnData();

            //关闭自定义页面
            this.dialogheaderVisibleHeaders = false;
            this.$message.success('自定义保存成功!');
          }else{
            this.$message.warning(res.data.msg);
          }
        });
      },
        //获取计算结果
        connect(nextFlag){
            this.$set(this.reminderList,'current',1)
            let baseUrl = process.env.VUE_APP_BASE_URL;
            // let baseUrl = process.env.VUE_APP_BASE_URL;
            //建立连接对象
            let socket = new SockJS("/api/wage/ws");
            // 获取STOMP子协议的客户端对象
            this.stompClient = Stomp.over(socket);
            //将socket对象存在session里
            // sessionStorage.setItem("stompClient", this.stompClient);
            this.stompClient.debug = null
            // 定义客户端的认证信息,按需求配置
            let headers = {
                'Authorization': 'Bearer ' + store.getters.accessToken
            };
            // 向服务器发起websocket连接
            this.stompClient.connect({headers}, frame => {
                console.log("websocket wage 连接成功");
                this.isEnable = true
                //所有的消息订阅都要在connect中完成
                // let toId = store.getters.userInfo.userId+""+this.listQuery.batchId;
                let toId = store.getters.userInfo.userId+""+this.listQuery.batchId;
                this.stompClient.subscribe('/user/' + toId + '/queue/wageCal/result/', msg => {
										this.$set(this.reminderList,'current',2)
                    console.log("接收到的消息：" + JSON.stringify(msg))
                    let message1 = msg.body
                    console.log(message1)
                    let resultState = message1.split("####")[0];
                    let resultMsg = message1.split("####")[1];
                    this.computeResultState = resultState;
                    this.computeResultMsg = resultMsg;
                    if(nextFlag&&resultState=='SUCCESS'){
                        this.loadingTxt = "待提交";
                        this.toSubmit(false);//确认
                    }else{
                        this.loading = false;
                        this.$router.go(0);//刷新当前页
                    }
                    this.$message.success(resultMsg);
// 										console.log(this.$refs['forms'+this.index])
//                     this.$refs['forms'+this.index]._getItemDataList();
                })
            })
        },
    }
  };
</script>

<style scoped>
	.customerBox >>> .el-tabs__new-tab
	{
		position: relative;
		top: -6px;
	}
  .btnCon{
    position: absolute;
    right: 0;
    top: -32px;
    display: flex;
    align-items: center;
  }
  .el-loading-spinner{
    display: block;
  }
	.light-theme #main > div.customerBox:not(.home) {
		background: transparent;
		padding: 0;
		box-shadow: none;
	}
	.payrollBox>>>.el-tabs__nav-wrap{
		width: calc(100% - 600px);
	}
	.tooltip{
		width: 200px;
		display: inline-block;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		vertical-align: middle;
		margin-right: 10px;
		font-size: 12px;
		color: #333;
	}
	.tooltip .icon{
		color: red;
		margin-right: 4px;
	}

</style>
